import { create } from 'zustand';
import { type TenantData } from '@/types/tenant';

interface TenantStore {
  tenantData: TenantData | null;
  setTenantData: (tenantData: TenantData) => void;
}

export const useTenantStore = create<TenantStore>((set, _get) => ({
  tenantData: null,
  setTenantData: (tenantData: TenantData) =>
    set((state) => ({
      ...state,
      tenantData: tenantData,
    })),
}));
